module.exports = "/../../dist/frontend/images/squareparts.webp?fcdb8acf6e162130028ba9d94c2d4df2";